import { render } from "./SuEditConfirm.vue?vue&type=template&id=04471800"
import script from "./SuEditConfirm.vue?vue&type=script&lang=js"
export * from "./SuEditConfirm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__